export default __webpack_public_path__ + "static/media/numbering.6a6c2700.svg";